enum DocumentRoutes {
  List = '/documents',
  Edit = '/documents/edit/:id',
}

export default DocumentRoutes
